var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"app":"","bottom":"","left":""},model:{value:(_vm.hasMessage),callback:function ($$v) {_vm.hasMessage=$$v},expression:"hasMessage"}},[_vm._v(_vm._s(_vm.message))])
}
var staticRenderFns = []

export { render, staticRenderFns }